import { Component, OnInit, signal } from "@angular/core";
import { CardModule } from "primeng/card";
import { TagModule } from "primeng/tag";
import { AvatarModule } from "primeng/avatar";
import { DividerModule } from "primeng/divider";
import { ChipModule } from "primeng/chip";
import { ProgressBarModule } from "primeng/progressbar";
import { ButtonModule } from "primeng/button";
import {
  SessionData,
  SessionService,
} from "../../../Utils/_services/session/session.service";

interface IAdminUser {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  registrationStep: number;
  registrationCompleted: boolean;
}

@Component({
  selector: "app-profile-detail",
  standalone: true,
  imports: [
    CardModule,
    TagModule,
    AvatarModule,
    DividerModule,
    ChipModule,
    ProgressBarModule,
    ButtonModule,
  ],
  templateUrl: "./profile-detail.component.html",
  styleUrl: "./profile-detail.component.css",
})
export class ProfileDetailComponent implements OnInit {
  constructor(private sessionService: SessionService) {}
  admin = signal<SessionData | undefined>(undefined);

  ngOnInit(): void {
    this.sessionService.sessionData$.subscribe(data => {
      if (data) {
        this.admin.set(data);
      }
    });
  }

  getFullName(): string {
    const adminData = this.admin();
    if (!adminData) return "";
    const userObj = adminData.user as any;
    const first = userObj.firstName || '';
    const last = userObj.lastName || '';
    if (first && last && first !== last) {
      return `${first} ${last}`;
    }
    return first || last || 'Admin';
  }

  getInitials(): string {
    const adminData = this.admin();
    if (!adminData) return "A";
    const userObj = adminData.user as any;
    const first = String(userObj.firstName || '').trim();
    const last = String(userObj.lastName || '').trim();
    
    if (first && last && first !== last) {
      return (first.charAt(0) + last.charAt(0)).toUpperCase();
    }
    return (first ? first.charAt(0) : 'A').toUpperCase();
  }

  getRoleDisplay(role: string): string {
    const roleMap: Record<string, string> = {
      super_admin: "Super Admin",
      admin: "Admin",
      moderator: "Moderator",
      user: "User",
    };
    return roleMap[role] || role;
  }

  getRoleSeverity(role: string): string {
    const severityMap: Record<string, string> = {
      super_admin: "p-tag-danger",
      admin: "p-tag-warning",
      moderator: "p-tag-info",
      user: "p-tag-secondary",
    };

    return severityMap[role] || "p-tag-secondary";
  }

  // getRoleSeverity(
  //   role: string
  // ): "success" | "secondary" | "info" | "warning" | "danger" | "contrast" {
  //   const severityMap: Record<
  //     string,
  //     "success" | "secondary" | "info" | "warning" | "danger" | "contrast"
  //   > = {
  //     super_admin: "danger",
  //     admin: "warning",
  //     moderator: "info",
  //     user: "secondary",
  //   };
  //   return severityMap[role] || "secondary";
  // }

  getRoleIcon(role: string): string {
    const iconMap: Record<string, string> = {
      super_admin: "pi pi-crown",
      admin: "pi pi-shield",
      moderator: "pi pi-user-edit",
      user: "pi pi-user",
    };
    return iconMap[role] || "pi pi-user";
  }

  // getProgressPercentage(): number {
  //   const adminData = this.admin();
  //   if (!adminData) return 0;
  //   return (adminData.user.registrationStep / 4) * 100;
  // }

  getPermissions(role: string): Array<{ name: string; granted: boolean }> {
    const allPermissions = [
      { name: "User Management", granted: false },
      { name: "Content Moderation", granted: false },
      { name: "System Settings", granted: false },
      { name: "Reports & Analytics", granted: false },
      { name: "Partner Management", granted: false },
      { name: "Financial Operations", granted: false },
    ];

    if (role === "super_admin") {
      return allPermissions.map(p => ({ ...p, granted: true }));
    } else if (role === "admin") {
      return allPermissions.map((p, i) => ({ ...p, granted: i < 4 }));
    } else if (role === "moderator") {
      return allPermissions.map((p, i) => ({ ...p, granted: i < 2 }));
    }

    return allPermissions;
  }
}
